module.exports = __webpack_public_path__ + "img/eg-9.501aa3ab.png";